export const LOADER_AREAS = "LOADER_AREAS";
export const LOADER_AREAS_DESC = "LOADER_AREAS_DESC";
export const LOADER_AREA = "LOADER_AREA";
export const SAVE_LOADER_AREA = "SAVE_LOADER_AREA";
export const GET_AREAS = "GET_AREAS";
export const GET_AREAS_DESC = "GET_AREAS_DESC";
export const GET_AREA = "GET_AREA";
export const FORM_AREA_FAIL = "FORM_AREA_FAIL";
export const AREAS_FAIL = "AREAS_FAIL";
export const AREA_FAIL = "AREA_FAIL";
